import Repository from './Repository'

export default {
    getProducts() {
        return Repository.get('products_all');
    },
    getProductPricesForCoupon (payload) {
        return Repository.get('promotion/' + payload.couponCode + '/products/' + payload.productIds +'?type=course');
    },
    getAllPromotions () {
        return Repository.get('author/promotions/type/course');
    },
    getStripeCoupons () {
        return Repository.get('author/stripe/coupons');
    },
    getProductPromotions (payload) {
        return Repository.get(`author/product_promotions/${payload.productId}/${payload.productType}`);
    },
    registerUserToCourse (payload) {
        return Repository.post('user/register/' + payload.courseId);
    }
}